import { format } from 'date-fns'

export const parseConfigAlcadas = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.id,
      'user-nome': item.usuarioAprovadorEmail,
      'user-de': item.minimo,
      'user-ate': item.maximo,
      'user-sem-recomendacao': item.itensSemRecomendacao
        ? `Sim (${item.lotesDe} a ${item.lotesAte} lotes)`
        : 'Não',
      // Valores crus (não exibidos na grade) para o export reimportável
      itensSemRecomendacao: !!item.itensSemRecomendacao,
      lotesDe: item.lotesDe ?? null,
      lotesAte: item.lotesAte ?? null
    })
  }

  return res
}
export const parseConfigUser = (data: any[]): any[] => {
  const grouped = new Map<string, any[]>()

  // Agrupar por idUsuarioCompras
  for (const item of data) {
    if (!grouped.has(item.idUsuarioCompras)) {
      grouped.set(item.idUsuarioCompras, [])
    }
    grouped.get(item.idUsuarioCompras)?.push(item)
  }

  const res: any[] = []

  for (const [idUsuarioCompras, items] of grouped.entries()) {
    const firstItem = items[0]

    const categorias = items
      .map(i => `${i.categoriaCompactaId} - ${i.categoriaCompactaNome}`)
      .filter((value, index, self) => self.indexOf(value) === index) // Remover duplicadas
      .join(' | ')

    const fornecedores = items
      .map(i => `${i.fornecedorId} - ${i.fornecedorNome}`)
      .filter((value, index, self) => self.indexOf(value) === index)
      .join(' | ')

    res.push({
      'id-id': idUsuarioCompras,
      'user-nome': firstItem.usuarioEmail,
      'user-categoria': categorias,
      'user-fornecedor': fornecedores,
      idUsuarioCompras: idUsuarioCompras,
      // Associações reais fornecedor x categoria (o export usa estas, sem cruzar listas)
      associacoes: items.map(i => ({
        empresaId: i.empresaId,
        fornecedorId: i.fornecedorId,
        fornecedorNome: i.fornecedorNome,
        categoriaCompactaId: i.categoriaCompactaId,
        categoriaCompactaNome: i.categoriaCompactaNome
      }))
    })
  }
  return res
}
export const parseConfigFerias = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.id,
      'comprador-principal': item.compradorPrincipalNome,
      'comprador-ferias': item.compradorFeriasNome,
      'comprador-fornecedor': item.fornecedorNome,
      'comprador-principal-email':
        item.compradorPrincipalEmail ?? item.compradorPrincipalNome,
      'comprador-ferias-email':
        item.compradorFeriasEmail ?? item.compradorFeriasNome,
      'comprador-principal-id': item.compradorPrincipalId,
      'comprador-ferias-id': item.compradorFeriasId,
      'comprador-fornecedor-id': item.fornecedorId,
      'user-de': format(new Date(item.dataInicio), 'dd/MM/yyyy'),
      'user-ate': format(new Date(item.dataFim), 'dd/MM/yyyy')
    })
  }

  return res
}
export const parseConfigTolerancia = (data: any[]): any[] => {
  const res = []
  for (const item of data) {
    res.push({
      'id-id': item.id,
      'user-nome': item.usuarioAprovadorEmail,
      'user-de': item.minimo,
      'user-ate': item.maximo,
      'nome-usuario': item.perfilNome,
      tolerancia: item.tolerancia
    })
  }

  return res
}
